// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1aRm5","label":"Radio_label__1lQoX","checkMark":"Radio_checkMark__3RRU5","disabled":"Radio_disabled__21B79"};